













































































import Vue from 'vue'
import { AxiosResponse } from 'axios'
import NotificationHelper from '../../util/notification_helper'
import { getHostAndDomain } from '../../util/helper'
import { Company, User } from '@/models'
import firebase from 'firebase/compat/app'
import ContactSupport from '@/pmd/components/common/ContactSupport.vue'
import MultipleUsersLogin from '../components/MultipleUsersLogin.vue'
import { OauthService } from '@/services'
const MoonLoader = () => import('@/pmd/components/MoonLoader.vue')
import OtpInput from './OtpInput.vue';
import moment from 'moment'

export default Vue.extend({
  metaInfo: {
    title: 'LoginOTP',
  },
  components: {
    MoonLoader,
    ContactSupport,
    MultipleUsersLogin,
    OtpInput
  },
  props: {
    email: {
      type: String,
      required: true,
    },
    password: {
      type: String,
      required: true,
    },
    emailMask: {
      type: String,
    },
    phoneMask: {
      type: String,
    },
    selectedCompanyId: {
      type: String
    },
    fromShopify: {
      type: Boolean
    }
  },
  data() {
    return {
      response: '',
      loading: false,
      logoURL: '',
      privacyURL: '',
      domainCompanyId: null,
      firstTime: true,
      otpChannel: this.emailMask ? 'email' : 'phone' as 'email' | 'phone',
      otpCode: '',
      length: 6,
      token:"",
      lastOtpSent: 0,
      allowOTPAfter: 5,
      allowMaxAttempt: 10,
      otpAttempt: 0
    }
  },
  computed: {
    isValidOtp() {
      return this.otpCode.length === 6
    }
  },
  methods: {
    handleOnChange(value) {
      this.otpCode = value
    },
    handleOnComplete(value) {
      this.otpCode = value
    },
    changeCounter() {
      if (this.lastOtpSent && this.lastOtpSent < this.allowOTPAfter) {
        this.lastOtpSent++;
        setTimeout(this.changeCounter, 1000);
      }
    },
    async requestForOtp() {
      if (this.loading) return;

      if (this.firstTime == false && this.lastOtpSent !== this.allowOTPAfter) {
        return;
      }

      this.otpCode = ""
      this.lastOtpSent = 0
      this.otpAttempt++

      const params = {
        ...getHostAndDomain(),
        email: this.email.trim(),
        password: this.password.trim(),
        deviceId: await this.$store.dispatch('getDeviceId'),
        deviceType: 'web',
        deviceName: navigator.userAgent,
        otpChannel: this.otpChannel,
      } as { [key: string]: any }

      this.loading = true

      if (
        this.domainCompanyId &&
        this.domainCompanyId !== 'YuTUZlUtrwBtvmgByZDW'
      ) {
        params.companyId = this.domainCompanyId || this.selectedCompanyId
      } else {
        params.companyId = this.selectedCompanyId
      }

      OauthService.loginWithEmail(params)
        .then((response: AxiosResponse) => {
          this.token = response.token
          this.firstTime = false
          this.loading = false
          this.lastOtpSent = 1
          this.changeCounter()
        })
        .catch(reason => {
          this.response = reason.response
            ? reason.response.data.message
            : 'Unable to log you in at this time.'
          this.loading = false
        })
    },

    async verifyOtp() {
      const _self = this

      this.loading = true
      this.response = ''

      const params = {
        ...getHostAndDomain(),
        email: this.email.trim(),
        password: this.password.trim(),
        deviceId: await this.$store.dispatch('getDeviceId'),
        deviceType: 'web',
        deviceName: navigator.userAgent,
        otpChannel: this.otpChannel,
        otp: this.otpCode,
        token: this.token,
      } as { [key: string]: any }

      if (
        this.domainCompanyId &&
        this.domainCompanyId !== 'YuTUZlUtrwBtvmgByZDW'
      ) {
        params.companyId = this.domainCompanyId || this.selectedCompanyId
      } else {
        params.companyId = this.selectedCompanyId
      }

      OauthService.loginWithEmail(params)
        .then((response: AxiosResponse) => {
          this.$store
            .dispatch('auth/set', {
              apiKey: response.apiKey,
              jwt: response.jwt,
              refreshJwt: response.refreshJwt,              
              userId: response.userId,
              companyId: response.companyId,
              authToken: response.authToken,
              refreshToken: response.refreshToken
            })
            .then(() => {
              return this.$auth.signInWithCustomToken(response.token)
            })
            .then(async () => {
              this.$store.dispatch('auth/set', {
                firebaseToken: response.token,
                jwt: response.jwt,
                refreshJwt: response.refreshJwt,                
                apiKey: response.apiKey,
                userId: response.userId,
                companyId: response.companyId,
                authToken: response.authToken,
                refreshToken: response.refreshToken
              })
              NotificationHelper.requestPermission()
              this.$store.dispatch('init')
              const loginCount = firebase.firestore.FieldValue.increment(1)
              await User.collectionRef()
                .doc(response.userId)
                .update({ login_count: loginCount })
              const url = this.$route.query.url
              if (url) {
                this.$router.push({
                  path: decodeURIComponent(url),
                  replace: true,
                })
              } else {
                if (this.fromShopify) {
                  this.$router.push({ name: 'shopify_dashboard', replace: true, query: this.$router.currentRoute?.query })
                } else {
                  this.$router.push({ name: 'dashboard', replace: true })
                }
              }
            }).finally(() => {
              this.loading = false
            })
        })
        .catch(reason => {
          this.response = reason.response
            ? reason.response.data.message
            : 'Unable to log you in at this time.'
          // this.isValidOtp = false
          this.loading = false
        })
    },

    async submit(selectedAgencyMultipleUsers?: string) {
      if (this.firstTime) {
        return this.requestForOtp()
      }

      return this.verifyOtp()
    },
    async selectAgencyMultipleUser(selectedAgencyMultipleUsers) {
      this.multipleUsersFound = null
      await this.submit(selectedAgencyMultipleUsers)
    },
    changeotpChannel(option: 'email' | 'phone') {
      this.firstTime = true
      this.otpChannel = option
    },
  },
})
